import SlickSlider from '../SlickSlider';

/**
 * Component: SecureCards
 */

export default class SecureCards {
    constructor() {
        this.selectors = {
            root: '[data-secure-cards]',
            slider: '[data-secure-cards-slider]',
            vw: $(window).width()
        };

        this.$rootElement = $(this.selectors.root);
        this.$slider = this.$rootElement.find(this.selectors.slider);
        this.init();
    }

    init() {
        if (this.selectors.vw < 481) {
            this.createSlider();
        }
    }

    createSlider() {
        const config = {
            autoplay: false,
            autoplaySpeed: 5000,
            arrows: true,
            fade: false,
            dots: false,
            slidesToScroll: 1,
            rows: 0,
            mobileFirst: true /* ,
            responsive: [
                {
                    breakpoint: 480,
                    settings: 'unslick'
                }
            ] */
        };

        return new SlickSlider(this.$slider, config);
    }
}
